import { messageService } from './message.service';
import { getLocale } from './locale-helper';
import { actions as _act } from '@/models/store.actions';
import store from '@/store/store';

export function handleGapiErrors(err) {
  let handled = false;
  if (err) {
    if (typeof err === 'string') {
      handled = true;
      messageService.error({ message: err });
    } else if ('error' in err && err.error === 'popup_closed_by_user') {
      handled = true;
    } else if ('error' in err && err.error === 'popup_blocked_by_browser') {
      handled = true;
      messageService.warn({
        message: getLocale('login.notifications.enablePopups')
      });
    } else if ('details' in err && err.details === 'Cookies are not enabled in current environment.') {
      handled = true;
      messageService.warn({
        message: getLocale('login.notifications.enableThirdPartyCookies')
      });
    }
  }
  return handled;
}

export function handleMsalErrors(err) {
  let handled = false;
  if (err) {
    if ('errorCode' in err) {
      if (err.errorCode === 'user_cancelled') {
        handled = true;
      } else if (err.errorCode === 'popup_window_error') {
        handled = true;
        messageService.warn({
          message: getLocale('login.notifications.enablePopups')
        });
      } else if (err.errorCode === 'interaction_required') {
        handled = true;
        messageService.warn({
          message: getLocale('login.notifications.enableThirdPartyCookies')
        });
      } else if (err.errorCode === 'access_denied') {
        handled = true;
        messageService.warn({
          message: getLocale('login.notifications.allowUseOfUserData')
        });
      }
    }
  }
  return handled;
}

export function handleFacebookErrors(err) {
  let handled = false;
  if (err) {
    if (err.message === 'facebook script loading error') {
      handled = true;
      messageService.error({
        message: getLocale('login.notifications.facebookLoginError').toString()
      });
    } else if (err.errorMessage) {
      handled = true;
      if (/cancelled/.test(err.errorMessage) === false) {
        let message = getLocale('login.notifications.facebookLoginError').toString();
        message = `${message}:<br/>${err.errorMessage}`;
        messageService.error({ message });
      }
    }
  }
  return handled;
}

export function isAuthenticated(): boolean {
  return store.getters[_act.AUTH_GET_ISLOGINEDGET];
}

export function isOrganisationUser(): boolean {
  let orgId = store.getters[_act.AUTH_GET_ORGID];
  return !!orgId && +orgId > 0;
}
